import React from "react";

export const isProd = () => {
	return process.env.NODE_ENV === "production";
};
//export const isDev = () => {
//	return process.env.NODE_ENV !== "production";
//};

export const logger = {
	log: (...args) => {
		if (isProd() === false) {
			console.log(...args);
		}
	},
	error: (...args) => {
		// エラーは本番でも見たいことが多いので残す
		console.error(...args);
	}
};

export const debugInfo = () => {
	logger.log(`NODE_ENV: ${process.env.NODE_ENV}`);
};
